// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1u4Yt","form":"styles_form__1jr5C"};